import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      className="footer"
      component="footer"
    >
      <Container maxWidth="md" >
        <Typography variant="body2" color="text.secondary" >
          <span className="text-muted">
            <img
              src="https://www.daikin.com.tr/Content/img/icons/daikin-logo.svg"
              alt="Daikin"
              className="brand-image elevation-0"
              height="15px"
            />
            {" | "}
            {t("copyright")} | DTAS - {t("system-develepment-section")} -{" "}
            {new Date().getFullYear()}
          </span>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
